import cCheckbox from '#themes/default/default/components/checkbox/checkbox.js';

import template from './legalAgreementCheckbox.html' with { type: 'html' };

export default {
	name: 'CLegalAgreementCheckbox',
	components: {
		cCheckbox
	},
	props: {
		isLoading: {
			type: Boolean,
			default: false
		},
		order: {
			type: Object,
			default: () => {}
		},
		terms: {
			type: Object,
			default: () => null
		},
		url: {
			type: Object,
			default: () => null
		}
	},
	computed: {
		checkboxLabel() {
			// CustomID
			if (this.isCustomId['CART-4095']) {
				return this.t('cart4095_cart_termsCheckbox');
			}
			return this.order.hasManualRenewalProduct ? this.t('cart_termsCheckboxManualRenewal') : this.t('cart_termsCheckboxAutoRenewal', {
				termsTitle: this.t('cart_termsTitle')
			});
		},
		isChecked() {
			return this.terms && this.terms.accepted;
		},
		wasSeen() {
			return this.terms && this.terms.seen;
		}
	},
	methods: {
		checkTerms(state) {
			this.$store.commit('SET_TERMS_AGREEMENT', {
				checkbox: true,
				accepted: state,
				seen: true
			});
		}
	},
	template
};
